import Marquee from "react-fast-marquee";
import { useLang } from "@/lib/i18n";

export const EditorialMarquee = () => {
  const { copy } = useLang();
  return (
    <div data-testid="editorial-marquee" className="bg-plum py-6 md:py-8 overflow-hidden border-y border-cream/10">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {copy.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif uppercase tracking-[0.3em] text-cream/90 text-lg md:text-2xl px-8 md:px-12 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-cream/40 inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
